import { getValues } from '@morph-mapper/utils';
import { EdgeId, Graph, NodeId } from '../../../types';

export const getTouchingNodeIds = (
  graph: Readonly<Graph>,
  edgeId: EdgeId
): NodeId[] => {
  const edge = graph.edges[edgeId];
  return [edge.from.nodeId, edge.to.nodeId];
};

export const getTouchingEdgeIds = (
  graph: Readonly<Graph>,
  nodeId: NodeId
): EdgeId[] => {
  return getValues(graph.edges)
    .filter((edge) => {
      if (edge.from.nodeId === nodeId || edge.to.nodeId === nodeId) {
        return true;
      }
      return false;
    })
    .map((edge) => edge.id);
};
